import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Moments} from "@common/utils/date/moments";
import {useAsyncFn} from "react-use";
import ReactPlayer from 'react-player'
import {isEmpty} from '@common/utils/common-utils'
import Page from '@common/enums/Page.enums'
import {openShare} from "@common/utils/app/appBridge";
import {convertPath} from "@common/utils/path/linkPath";
// Images
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import Heart from "../../assets/image/icon_heart.svg"
import ActiveHeart from "../../assets/image/icon_heart_active.svg"
import Share from "../../assets/image/icon_share.svg"
import Save from "../../assets/image/icon_save.svg"
import Prev from "../../assets/image/icon_prev.svg";
import {useAuth} from "@common/contexts/auth/AuthProvider";
import {useHistory, useLocation, useParams} from "react-router-dom";
import useFetch from "@common/hooks/fetch/useFetch";
// API
import {
  getAdicPlayList,
  postAdicPlayList,
  postAdicPlayListAd,
  postMyAdWatchViewList,
} from '../../../common/services/restapi/mypage/index'
import {
  getAdCategoryList,
  getAdDetailView,
  getAdLikeStatus,
  postAdLikeStatus,
  removeAdLikeStatus
} from "@common/services/restapi/ad";
// 공통 컴포넌트
import SmallCardHorizontal from "../set/SmallCardHorizontal";
import BtnText from "../component/BtnText";
import BtnMedium from "../component/BtnMedium";
// 모달
import {Modal} from "react-bootstrap";
// 토스트
import {Slide, toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import queryString from "query-string";


function AdCategoryDetailView() {

  const {category, ukey} = useParams();

  // Auth
  const {adicUser, authenticated} = useAuth();

  const location = useLocation();

  // History
  const history = useHistory();
  const handleGoBack = useCallback(() => {
    history.goBack();
  }, []);


  // 공유하기
  const handleShare = () => {
    openShare('ADIC', '광고정보센터', `https://m.ad.co.kr/mobile${location.pathname}`);
  };

  //TODO: 추후 enumify 으로 대체필요
  const [imgContents, setImgContents] = useState(["print", "internet", "interb", "mobile"]);

  const [saveModal, setSaveModal] = useState(false);

  const [inputTitle, setInputTitle] = useState(false);

  const {data: detailView} = useFetch(() => getAdDetailView(category, ukey), [], {});


  const [selectedThing, setSelectedThing] = useState("");

  const [myAdWatchView, handleMyAdWatchView] = useAsyncFn(async (reqBody) => {
    if (!myAdWatchView.loading) {
      await postMyAdWatchViewList(reqBody);
    }
  }, []);

  const {data: adLikeStatus, refetch} = useFetch(() => getAdLikeStatus(category, ukey), [category, ukey], {});

  // 좋아요 기능
  const [postAdLike, handlePostAdLike] = useAsyncFn(async (category, ukey) => {
    if (!postAdLike.loading) {
      await postAdLikeStatus(category, ukey);
    }
  }, []);

  const [removeAdLike, handleRemoveAdLike] = useAsyncFn(async (category, ukey) => {
    if (!removeAdLike.loading) {
      await removeAdLikeStatus(category, ukey);
    }
  }, []);

  const handleLike = async () => {
    // 좋아요 서버 등록
    await handlePostAdLike(category, ukey);
    // 좋아요 상태 조회
    await refetch()
  };

  const handleUnlike = async () => {
    // 좋아요 서버 삭제
    await handleRemoveAdLike(category, ukey);
    // 좋아요 상태 조회
    await refetch()
  };


  // 내가 본 광고 저장 기능
  useEffect(() => {
    if (authenticated) {
      const reqBody = {
        adId: ukey,
        adCategory: category
      };
      handleMyAdWatchView(reqBody);
    }
  }, [authenticated]);


  // 재생목록 저장 기능
  const [postPlaylist, handlePostPlaylist] = useAsyncFn(async (reqBody) => {
    if (!postPlaylist.loading) {
      await postAdicPlayList(reqBody);
      // 새 플레이리스트 상태 조회
      await refetchPlaylist();
      // 닫기
      setInputTitle(false);
    }
  }, []);

  const [postPlaylistAd, handlePostPlaylistAd] = useAsyncFn(async (adId, playlistId, category) => {

    setSaveModal(false);

    isSuccess();

    if (!postPlaylistAd.loading) {
      await postAdicPlayListAd({adId: adId, playlistId: playlistId, category: category});
    }
  }, []);

  const handleNewPlaylist = async (inputedTitle) => {

    // 새 플레이리스트 서버 등록
    const reqBody = {
      userId: adicUser.userId,
      title: inputedTitle
    };

    await handlePostPlaylist(reqBody);
  };

  const {data: adicPlayList, refetch: refetchPlaylist} = useFetch(() => getAdicPlayList(), [], []);

  const [inputFocus, setInputFocus] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleUserInput = (e) => {
    setInputValue(e.target.value);
  }

  const clearUserInput = () => {
    setInputValue("");
  }

  const getPlaylistInfo = (thing) => {
    setPushPlaylistAd(thing.id)
  }

  const handleVideo = () => {

  }
  const [pushPlaylistAd, setPushPlaylistAd] = useState()

  const isSuccess = () => toast.success("저장되었습니다", {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    closeButton: false
  });

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">광고보기</h3>
      </div>

      {
        detailView && detailView.activeYN ?
      <div className={`ad-detail-view ${imgContents.includes(category) ? "" : "video"}`}>
        {
          imgContents.includes(category) ?
            <div className="img-box">
              {
                detailView.contentFullUrl && <img src={detailView.contentFullUrl.replace("http:", "https:")} alt=""/>
              }
            </div>
            :
            <div className="player-wrapper">
              <ReactPlayer
                className='react-player'
                url={detailView.contentFullUrl}    // 플레이어 url
                width='100%'         // 플레이어 크기 (가로)
                height='100%'        // 플레이어 크기 (세로)
                playing={!saveModal}        // 자동 재생 on
                muted={true}          // 뮤트 on
                controls={true}       // 플레이어 컨트롤 노출 여부
                light={false}         // 플레이어 모드
                pip={true}            // pip 모드 설정 여부
                poster={detailView.thumbnail}   // 플레이어 초기 포스터 사진
                onEnded={() => handleVideo()}  // 플레이어 끝났을 때 이벤트
                config={{ file: {
                    attributes: {
                      controlsList: 'nodownload'  // 다운로드 방지
                    }
                  }}}
              />
            </div>
        }

        <div className="header-box">
          <h4 className="title">{detailView.title}</h4>
          <div className="row-box">
            <div className="company brand">브랜드 <span>{detailView.brand}</span></div>
            <div className="company advertiser">광고주 <span>{detailView.advertiser}</span></div>
          </div>
          <div className="row-box between">
            <div className="left-box">
              <div className="view-count">
                <img src={ViewIcon} alt=""/>
                <span>{detailView.rcount}</span>
              </div>
              <img src={Split} alt=""/>
              <div className="created-date">{Moments.Format(detailView.wdate, 'yyyy.MM.DD')}</div>
            </div>
            <div className="right-box">
              {
                authenticated &&
                <button onClick={() => !adLikeStatus.isLike ? handleLike() : handleUnlike()}>
                  {
                    adLikeStatus.isLike ?
                      <img src={ActiveHeart} alt=""/>
                      :
                      <img src={Heart} alt=""/>
                  }
                </button>
              }

              <button onClick={handleShare}>
                <img src={Share} alt=""/>
              </button>
              {
                authenticated &&
                <button onClick={() => setSaveModal(true)}>
                  <img src={Save} alt=""/>
                </button>
              }
            </div>
          </div>
        </div>
        {!isEmpty(detailView) && <RelatedAdList detailView={detailView} ukey={ukey} category={category}/>}

        <Modal show={saveModal} dialogClassName={`filter-modal save-playlist`}>
          <Modal.Body>
            <div className="header-band">
              <h5>광고저장</h5>
              <BtnText text="새 재생목록" leftIcon="mdi mdi-plus-box-outline" color="blue"
                       onClick={() => setInputTitle(true)}/>
            </div>
            <div className="filter-list">
              <div className={`radio-wrap ad-to-playlist`}>
                {
                  adicPlayList.map((thing, i) =>
                    <button className={`radio-btn radio-box`} onClick={() => {
                      setSelectedThing(thing.title);
                      getPlaylistInfo(thing)
                    }} key={`playlist-${i}`}>
                      {
                        selectedThing === thing.title ? <i className="mdi mdi-radiobox-marked"/> :
                          <i className="mdi mdi-radiobox-blank"/>
                      }
                      {thing.title}
                    </button>
                  )
                }
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <BtnMedium type="button" color="blue" text="저장"
                       onClick={() => handlePostPlaylistAd(Number(ukey), pushPlaylistAd, category)}/>
            <BtnMedium type="button" color="black" text="닫기" onClick={() => setSaveModal(false)}/>
          </Modal.Footer>
        </Modal>
        <Modal show={inputTitle} dialogClassName={`filter-modal new-playlist`}>
          <Modal.Body>
            <div className="header-band">
              <h5>재생목록명 입력</h5>
            </div>
            <div className="filter-list">
              <div className={`text-input-wrap playlist-input`}>
                <div className={`text-input-box ${inputFocus ? "focus" : ""}`}>
                  <input
                    type="text"
                    value={inputValue}
                    onChange={handleUserInput}
                    placeholder="재생목록명을 입력하세요"
                    onFocus={() => setInputFocus(true)}
                    onBlur={() => setInputFocus(false)}/>
                  <i className={`right-icon mdi mdi-close-circle`} onClick={clearUserInput}/>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <BtnMedium type="button" color="blue" text="저장" onClick={() => handleNewPlaylist(inputValue)}/>
            <BtnMedium type="button" color="black" text="닫기" onClick={() => setInputTitle(false)}/>
          </Modal.Footer>
        </Modal>
        <ToastContainer
          position="bottom-center"
          autoClose={4000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Slide}
        />
      </div>
          :
          <div className={'ad-detail-view disabled'}>
            해당광고는 비활성된 상태로 재생을 할 수 없습니다.
          </div>
      }
    </>
  )
}

function RelatedAdList({detailView, ukey, category}) {
  const {playMode: noewPlayMode = null} = queryString.parse(location.search);
  const relatedSearch = useMemo(() => {
    if (isEmpty(detailView)) return null;
    return {
      category: category,
      category1: detailView.category1,
      category2: detailView.category2,
      pageSize: Page.size.defaultSize + 1
    }
  }, [detailView]);

  const [playMode, setPlayMode] = useState(noewPlayMode);

  const {data: adRelatedList} = useFetch(() => getAdCategoryList(relatedSearch), [relatedSearch], {});
  const {adRelatedListData} = useMemo(() => {
    let adPlayArray = [];
    let adRelatedListData = [];
    let adPlayListArr = [];
    let nextIndexUkey = null;
    const realatedAdUkey = Number(ukey)
    if (adRelatedList && adRelatedList.adList && adRelatedList.adList.length > 0) {
      const adRelatedListResults = adRelatedList.adList;
      const detailUkeyIndex = adRelatedListResults.findIndex(ad => ad.ukey === realatedAdUkey);
      adRelatedListData = [];
      if (detailUkeyIndex > -1) {
        adRelatedListData = adRelatedListResults.filter(ad => ad.ukey !== realatedAdUkey);
      } else if (adRelatedListResults.length === Page.size.defaultSize + 1){
        adRelatedListData = adRelatedListResults.pop();
      } else {
        adRelatedListData = adRelatedListResults;
      }

      // if (playMode === 'relay') {
      //   let randomNumber = Math.floor(Math.random() * adRelatedListDataLength);
      //   nextIndexUkey = adRelatedListData[randomNumber].ukey;
      // } else {
      //   const nowIndex = nowPlayAdIndex < (adRelatedListDataLength.length - 1) ? nowPlayAdIndex + 1 : 0;
      //   nextIndexUkey = adRelatedListData[nowIndex].ukey;
      // }
    }
    return {
      adRelatedListData
    }
  }, [playMode, adRelatedList]);

  // const handleVideo = () => {
  //   if (playMode === 'relay') {
  //     window.location.replace(`/mapp/ad/${category}/${nextIndexUkey}?playMode=relay`)
  //   } else if (playMode === 'random') {
  //     window.location.replace(`/mapp/ad/${category}/${nextIndexUkey}?playMode=random`)
  //   }
  // }

  return (
    <div className="body-box">
      {
        adRelatedListData && adRelatedListData.length > 0 &&
        <>
          {/*{category !== ('print' || 'internet' || 'mobile') &&*/}
          {/*<div className="btn-box">*/}
            {/*<button className={`relay ${playMode === "relay" ? "clicked" : ""}`} onClick={() => setPlayMode("relay")}>*/}
              {/*<img src={Relay} alt=""/> 순차 재생*/}
            {/*</button>*/}
            {/*<button className={`random ${playMode === "random" ? "clicked" : ""}`}*/}
                    {/*onClick={() => setPlayMode("random")}>*/}
              {/*<img src={Suffle} alt=""/> 랜덤 재생*/}
            {/*</button>*/}
          {/*</div>*/}
          {/*}*/}
          <h4 className="headline">연관광고</h4>
          <div className="row-box">
            <div className="video-count">광고 <span>{adRelatedListData.length}</span>개</div>
          </div>
          <div className="ad-list">
            <SmallCardHorizontal
              source={adRelatedListData}
              link={`/ad/${category}/`}
            />
          </div>
        </>
      }
    </div>
  )
}

export default AdCategoryDetailView;
